/**
 * サービス状態
 */
export var ServiceStatuses;

(function (ServiceStatuses) {
  /**
   * 契約中
   */
  ServiceStatuses[ServiceStatuses["UnderContract"] = 0] = "UnderContract";
  /**
   * 通知済
   */

  ServiceStatuses[ServiceStatuses["Deleted"] = 1] = "Deleted";
  /**
   * 中断中
   */

  ServiceStatuses[ServiceStatuses["Suspended"] = 2] = "Suspended";
})(ServiceStatuses || (ServiceStatuses = {}));